var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"setBgImg",style:(`height:${_vm.height+50}px`)},[_c('div',{staticClass:"showView",style:(`height:${_vm.height+30}px;width:${_vm.width-30}px`)},[_vm._m(0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userInfoWrap"},[_c('div',{staticClass:"userData"})])
}]

export { render, staticRenderFns }